/* Monika Blunder Beauty â€” shared PDP behaviour (reusable across all products)
   Built to coexist with the Variant Wizard + Swatches app, which owns the
   variant picker and the per-shade gallery. This file NEVER renders swatches
   or swaps gallery images. It only adds:
     1. a sticky mobile add-to-cart bar that proxies the real add-to-cart button
     2. desktop hover-zoom on whatever image the app is currently showing
   Scoped to body.mbb-pdp. Safe to load on every MBB product template. */
(function(){
  document.body.classList.add('mbb-pdp');

  /* ---- sticky mobile ATC ---- */
  var bar = document.querySelector('[data-mbb-sticky-atc]');
  var realBtn = document.querySelector('.product-form__submit') ||
                document.querySelector('button[name="add"]');
  if(bar && realBtn){
    var proxy = bar.querySelector('[data-mbb-sticky-add]');
    if(proxy) proxy.addEventListener('click', function(){ realBtn.click(); });

    var io = new IntersectionObserver(function(entries){
      var v = entries[0].isIntersecting;
      document.body.classList.toggle('mbb-show-sticky', !v && window.innerWidth < 750);
    }, {threshold:0});
    io.observe(realBtn);

    /* Keep the sticky price in sync no matter HOW the variant changes.
       The app switches shades via its own handlers (not always a native
       <select> change), so we watch the price node for any text update
       instead of listening for change events. App-agnostic. */
    var priceEl = document.querySelector('.price__regular .price-item, .price .price-item--last, .price .price-item');
    var px = bar.querySelector('[data-mbb-sticky-price]');
    if(priceEl && px){
      var sync = function(){ var t = priceEl.textContent.trim(); if(t) px.textContent = t; };
      sync();
      new MutationObserver(sync).observe(priceEl, {childList:true, subtree:true, characterData:true});
    }
  }

  /* ---- desktop hover zoom (delegated) ----
     Delegation on the gallery container so zoom keeps working after the app
     swaps gallery images when a new shade is selected. */
  if(window.matchMedia('(min-width:990px)').matches){
    var gallery = document.querySelector('.product__media-list, .product__media-wrapper, .product-media-container, .product__column-sticky, .product__media-gallery, .product');
    if(gallery){
      var zoom = function(e){
        var img = e.target.closest('img'); if(!img) return;
        var wrap = img.closest('.product__media, .product-media, .product__media-item') || img.parentElement;
        if(!wrap) return;
        wrap.style.overflow = 'hidden';
        var r = wrap.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
        img.style.transform = 'scale(1.6)'; img.style.transition = 'transform .05s';
      };
      gallery.addEventListener('mousemove', zoom);
      gallery.addEventListener('mouseout', function(e){
        var img = e.target.closest('img'); if(img) img.style.transform = '';
      });
    }
  }
})();